import { render, staticRenderFns } from "./RegistrySelector.vue?vue&type=template&id=0e74ccb4"
import script from "./RegistrySelector.vue?vue&type=script&lang=js"
export * from "./RegistrySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports